import {
  SET_BLOGS_STATUS,
  SET_BLOGS_CATEGORY
} from '@/store/mutation-types'

export default {
  [SET_BLOGS_STATUS] (state, payload) {
    state.searchBlogsStatus = payload
  },
  [SET_BLOGS_CATEGORY] (state, payload) {
    state.searchBlogsCategory = payload
  },
}



// WEBPACK FOOTER //
// ./src/components/blogs/store/mutations.js